import { useState } from 'react';
import axios from 'axios';
import { API_STATUS } from '../utils/constants';
import { toastWarn } from '../utils/toasts';

export function useDelete() {
   const [deleteStatus, setDeleteStatus] = useState(API_STATUS.IN_PROGRESS);

   const deleteChanges = async (payload, url) => {
      try {
         setDeleteStatus(API_STATUS.IN_PROGRESS);
         const response = await axios.delete(url, {
            headers: {
               'content-type': 'application/json',
            },
            data: payload,
         });

         if (response.status !== 200) {
            toastWarn(response.data.message);
            setDeleteStatus(API_STATUS.FAILED);
         } else {
            setDeleteStatus(API_STATUS.COMPLETED);
         }
      } catch (error) {
         console.warn('Error in Delete records', error);
         setDeleteStatus(API_STATUS.FAILED);
         toastWarn(error.message);
      }
   };

   return { deleteStatus, deleteChanges };
}
